import React, { TableRow, CircularProgress, TableCell } from '@mui/material';
import { TableLoadingBarProps } from './TableLoadingBarProps';

export const TableLoadingBar = (props: TableLoadingBarProps) => {
	return (
		<TableRow>
			<TableCell colSpan={props.colSpan} align='center'>
				<CircularProgress />
			</TableCell>
		</TableRow>
	);
};
